import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

if (typeof document !== "undefined") {
  document.documentElement.classList.add("dark");
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    const base = (process.env.PUBLIC_URL || "").replace(/\/+$/, "");
    const url = `${base}/sw.js`;
    navigator.serviceWorker.register(url).catch(() => {});
  });
}
